export default __webpack_public_path__ + "36d5654778e87ad271b6c03ee285828c.png";